import { saasRequest } from 'websockets/utils/SaaSUtils';

export const getSaasSpaces = async ({ tenantUri, webIntegrationId }) => {
    return await saasRequest(
        tenantUri,
        '/api/v1/spaces?limit=100',
        webIntegrationId
    ).catch((err) => {
        console.error(err);
        throw err;
    });
};
